/*  ==========================================================================
    IMPRESSIONS V2
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

export function initImpressionsV2($element) {

    // magnific popup
    utils.mfp.initGallery($element);

    // initialize slider
    let $sliderContainer = $element.find('.bn-impressions-v2__slider'),
        sliderOverrides = {
            nextArrow: vars.slick_nextArrowV2,
            pauseOnHover: true,
            prevArrow: vars.slick_prevArrowV2,
            slidesToShow: 2
        };
    utils.slickCarousel.initPluralSlider($sliderContainer,sliderOverrides);

    $('.bn-impressions-v2__head').each(function () {
        if($(this).find('.bn-impressions-v2__title').length){
            $(this).addClass('bn-titleset');
        }
    });
}


// WEBPACK FOOTER //
// ./source/js/modules/lib/impressions-v2.js